import axiosInterceptor from '../helpers/axiosInterceptor';
import { EXPERT_GET_DASHBOARD_DETAILS } from "../Constants";

function getDashboardDetails() {
      return axiosInterceptor.get(EXPERT_GET_DASHBOARD_DETAILS);
}

export {getDashboardDetails};